import React, { useEffect, useState } from 'react';
import image from '../../../Assets/images/commonImages/dektopBanner.webp';
import image1 from '../../../Assets/images/commonImages/ipadBanner.webp';
import Footer from '../../../components/Footer/Footer';
import PostHeader from '../../../components/Header/PostHeader';
import './services.scss';
import { Helmet } from 'react-helmet';
import Button from '../../../components/Button/Button';
import { globalVal } from '../../../global/globalvalues';
import { seoData } from '../../../global/seoData';
import { DR, ILD, IR } from '../../../global/texts/postActivation/services';
import ManageServices from './ManageServices';
import image11 from '../../../Assets/images/PostActivation/Services/Path.svg';
import image2 from '../../../Assets/images/PostActivation/Services/call.svg';
import image3 from '../../../Assets/images/PostActivation/Services/Shape.svg';
import { useSelector } from 'react-redux';
import { CircularProgress } from '@material-ui/core';

type initialProps = {
    history: any;
};

const AstoundServices = (props: initialProps) => {
    const [manageServices, setManageServices] = useState<boolean>(false);
    const [passedName, setPassedName] = useState<any>('');
    const [configVals, setConfigVals] = useState<any>('');
    const [loader, setLoader] = useState<boolean>(true);

    const configState = useSelector((state: any) => state.billing.config);

    useEffect(() => {
        window.scroll(0, 0);
    }, []);

    useEffect(() => {
        if (configState && configState.status === 'SUCCESS' && configState.data && configState.data.configs) {
            setConfigVals(configState.data.configs);
            setLoader(false);
        }
    }, [configState]);

    const hideManageServices = () => {
        setManageServices(false);
    };
    const astoundServices: any = {
        mainPage: [
            {
                title: 'International Roaming',
                img: image11,
                text: 'Stay connected while you travel abroad.',
                btnText: 'MANAGE',
                shortName: 'IR',
                alt: 'Flight icon',
                isDisable: configVals?.IS_IR_ENABLED === 'ENABLE' ? false : true,
            },
            {
                title: 'International Calling',
                img: image2,
                text: 'Call anywhere in the world, from the U.S.',
                btnText: 'MANAGE',
                shortName: 'ILD',
                alt: 'Call icon',
                isDisable: configVals?.IS_ILD_ENABLED === 'ENABLE' ? false : true,
            },
            {
                title: 'Domestic Roaming',
                img: image3,
                text: 'Stay connected anywhere in the U.S.',
                btnText: 'MANAGE',
                shortName: 'DR',
                alt: 'American flag icon',
                isDisable: configVals?.IS_DR_ENABLED === 'ENABLE' ? false : true,
            },
        ],
    };

    return (
        <>
            {loader ? (
                <div className="loaderCheck">
                    <CircularProgress />
                </div>
            ) : (
                <div className="ServicesMain">
                    <Helmet>
                        <title>{seoData.services.title}</title>
                        <meta property="og:site_name" name="site_name" content={globalVal && globalVal.long_name} />
                        <meta property="og:title" name="title" content={seoData.services.title} />
                        <meta property="og:description" name="description" content={seoData.services.description} />
                        <meta name="keywords" content={seoData.services.keywords} />
                        <meta name="robots" content="noindex, nofollow" />
                        <meta
                            property="twitter:site_name"
                            name="site_name"
                            content={globalVal && globalVal.long_name}
                        />
                        <meta name="twitter:title" content={seoData.services.title} />
                        <meta name="twitter:description" content={seoData.services.description} />
                        <link rel="canonical" href={seoData.services.canonicalUrl} />
                    </Helmet>
                    <PostHeader 
                        history={props.history} 
                        showServiceTab={configVals?.SERVICE_TAB === 'ENABLE' ? true : false}
                    />
                    <div className="OverlayPostServices">
                        <div className="carouseImage">
                            <img className="web" src={image} width="100%" alt="illustration" />
                            <img className="iPadPro" src={image1} width="100%" alt="illustration" />
                            <img className="iPad" src={image1} width="100%" alt="illustration" />
                            {/* <img className="mobile" src={image3} height="250" alt="illustration" /> */}
                            <div className="contentCarousel">
                                <h1 className="Goodbye-mobile-store">
                                    Services
                                    {/* {isLoader ? <Skeleton className="skeletonRadius" /> : astoundServicesPage.overlay} */}
                                </h1>
                            </div>
                        </div>
                    </div>
                    {manageServices ? (
                        <ManageServices
                            passedName={passedName}
                            history={props.history}
                            data={
                                passedName === 'International Roaming'
                                    ? IR
                                    : passedName === 'International Calling'
                                    ? ILD
                                    : DR
                            }
                            hideManageServices={hideManageServices}
                        />
                    ) : (
                        <div className="servicesCardContainer">
                            {astoundServices.mainPage.map((data: any, idx: any) => {
                                return (
                                    <div className="servicesCard" key={idx}>
                                        <div className="servicesTitle">{data.title}</div>
                                        <div className="image">
                                            <img src={data.img} alt={data.alt} />
                                        </div>
                                        <div className="servicesText">{data.text}</div>
                                        <div className="manageBtn">
                                            <Button
                                                primary={true}
                                                onClick={() => {
                                                    setManageServices(true);
                                                    setPassedName(data.title);
                                                    window.scroll(0, 0);
                                                }}
                                                disabled={data.isDisable}
                                            >
                                                {data.btnText}
                                            </Button>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                    <Footer />
                </div>
            )}
        </>
    );
};

export default AstoundServices;
